import axios from "@/api/axios";
import publicApi from "@/api/publicApi";
import appApi from "@/api/appApi";

export function httpCrud({ client, basePath }) {
  const path = basePath.replace(/\/+$/, "");

  const withQuery = (q) => (q ? (q.startsWith("?") ? q : `?${q}`) : "");

  return {
    fetch: (query) => client.get(`${path}${withQuery(query)}`),
    search: (query) => client.get(`${path}${withQuery(query)}`),
    create: (data) => client.post(path, data),
    update: (id, data) => client.patch(`${path}/${id}`, data),
  };
}

export function appApiCrud(key) {
  const api = appApi[key];
  if (!api) throw new Error(`[appApiCrud] key inválida: ${key}`);

  return {
    fetch: (query) => api.fetch(query),
    search: (query) => (api.search ? api.search(query) : api.fetch(query)),
    create: (data) => api.create(data),
    update: (id, data) => api.update(id, data),
  };
}

export const clients = {
  axios,
  publicApi,
  appApi,
};
